import * as React from "react";
const NotificationBell = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width={25} height={24} fill="none">
    <path
      stroke="#838383"
      strokeWidth={2}
      d="M21.4 19.202v.431H3.533v-.432a10.6 10.6 0 0 0 1.717-2.064l.025-.04.022-.041a9.4 9.4 0 0 0 1.007-3.589l.003-.037v-3.332a6.207 6.207 0 0 1 5.357-6.16l.773-.108.743.095a6.207 6.207 0 0 1 5.42 6.172v3.333l.003.037a9.4 9.4 0 0 0 1.007 3.589l.023.045.027.042c.49.758 1.075 1.45 1.74 2.06Z"
    />
    <path fill="#838383" d="M10.713 21.333a1.767 1.767 0 0 0 3.5 0h-3.5Z" />
  </svg>
);
export default NotificationBell;
